module.exports = __webpack_public_path__ + "mw.e7a90e05d3b9f4633aa9.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/mw.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/mw.svg
// module chunks = styles